import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import echarts from "echarts";
import elementui from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/style/table.scss";
import "./assets/style/global.css";
import "./assets/style/global.scss";
import "./assets/style/element-variables.scss"; //改变主题颜色
import Moment from "moment";
import Vuex from "vuex";
import "./resgisterServiceWorker";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
// import jquery from "jquery"
import constant from "./utils/constants.js";
import utils from "./utils/util.js";
import "./assets/font/font.css";
import "./assets/iconfont/iconfont.css";
import "./assets/iconfont/iconfont.js";
import "./assets/reset.css";
import "./assets/font/iconfont.css";
import "./assets/rem";
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
import gojs from "gojs";
import clipboard from "clipboard";
import { loginController } from "@/api/activityController";
import { getSellerInfo } from "@/api/sellerController";
import { authCheck } from "@/api/activityController";
import VueVideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
import { checkPermisson } from "@/common/permission";
import common from "./common/decrypt";
import decryptBatch from "./common/batchDecrypt";
import commonOptimization from "./common/commonOptimization";
import actInfoSetting from "@/views/integralCenter/components/actInfoSetting.vue";
import jdTitle from "@/components/common/Title/index.vue";
import orderShopInfo from "@/views/integralCenter/components/orderShopInfo.vue";

Vue.component("jdTitle", jdTitle);
Vue.component("orderShopInfo", orderShopInfo);
Vue.prototype.clipboard = clipboard;
//图片拖动排序
import VueDND from "awe-dnd";

Vue.use(VueDND);
Vue.use(Viewer);
Vue.use(VueVideoPlayer);

import VueClipboard from "vue-clipboard2";

Vue.use(VueClipboard);

/***************引入gojs为原型函数*************************************/
Vue.prototype.$go = gojs;
Vue.prototype.$make = gojs.GraphObject.make;

// 全局京豆总数判断三个必填项 row.quantityTotal京豆总数   row.price京豆单个奖励  row.prizeCount填写的京豆总份数额
// Vue.prototype.$jingdouTotal = (row) => {
//   if (row.quantityTotal && row.prizeCount && Number(row.prizeCount) * Number(row.price) > row.quantityTotal) {
//     return "";
//   } else {
//     return row.prizeCount;
//   }
// }
Vue.prototype.$jingdouTotal = commonOptimization.jingdouTotal;
Vue.prototype.$getDate = commonOptimization.getDate;
Vue.prototype.$getActDate = commonOptimization.getActDate;
Vue.prototype.$commonUrl = commonOptimization.commonUrl;
Vue.prototype.$toChinesNum = commonOptimization.toChinesNum;
Vue.component("actInfoSetting", actInfoSetting);
//el-input挂载
import onlyNumber from "@/directive/el-input"; //添加此行=>自定义全局指令

Vue.use(onlyNumber); //添加此行=>使用该全局指令

Vue.use(Vuex);

Vue.use(Moment);
Vue.use(elementui, { size: "small", zIndex: 3000 });
Vue.use(echarts);
Vue.use(VueAwesomeSwiper /* { default global options } */);
Vue.use(constant);
Vue.use(utils);

// Vue.prototype.jq = jquery
// 双击解密
Vue.prototype.$decrypt = common;

// 批量解密
Vue.prototype.$decryptBatch = decryptBatch;

Vue.prototype.moment = Moment;

Vue.prototype.$echarts = echarts;

Vue.prototype.$myVue = Vue;

Vue.config.productionTip = false;

Vue.prototype.bus = new Vue();

// 配置当前玩法的默认分享海报
// id：玩法id  返回值为图片地址
Vue.prototype.getDefaultSharePic = function(id) {
  switch (id) {
    case 1: // 签到
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_641dcd9356ce43768b45e127fba176b3.png";
    case 2: // 每日限时抢
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_c877055d2d5e450a90be5101f38d30a4.png";
    case 3: // 关注店铺有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_4d33db69ca024903843d99a9a79e2a53.png";
    case 4: // 邀请开卡有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_d179bed0c9f94747a1935b0323856796.png";
    case 5: // 邀请关注有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_f1b051fe8b6c43d787bec7510bf70762.png";
    case 6: // 完善信息有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_878e1739c2214440b312ea8a235446a4.png";
    case 8: // 幸运抽奖
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_c1f527acd10947528b7ee35398fdb062.png";
    case 16: // 下单有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_e2457cd5a00e4059b8e4c38f9c59cfce.png";
    case 17: // 首单专享礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/首购专享礼.png";
    case 18: // 复购有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_18256c6db9ad49eeaff4875b46cd5738.png";
    case 19: // 下单抽奖
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_d70f9a4540eb4ed6b6d6c0c500f3b970.png";
    case 20: // 评价有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_5596ffd7934a4357bee8a162a97b57d3.png";
    case 21: // 裂变神券
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_5cf953d0208e4a9eb8e7217ddabc8cc6.png";
    case 22: // 天降红包雨
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_baed0f4b975b42e2bafceb8b85df4fef.png";
    case 23: // 欢乐娃娃机
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_794a6b6194d34dbea0f4b7c77d197f2c.png";
    case 24: // 大家来找茬
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_b9ecef75382a4dcdb217eba4daf8429f.png";
    case 27: // 预售有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_7340c47bbeda451ea8eb39de2644510e.png";
    case 28: // 预售抽奖
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_9e504eae36d148a294359f00875fd540.png";
    case 31: // 超级裂变券
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_57a1234181024b3b850f6596b32c67e3.png";
    case 34: // 加购有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_5108d958fef14a688d435033dbf29a90.png";
    case 35: // 积分锁权
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_lockAuthShare.jpg";
    case 36: // 下单冲榜
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/share_xdcb.png";
    case 37: // 派样回购礼
      let loginUserInfo = JSON.parse(
        window.sessionStorage.getItem("loginUserInfo")
      );
      return loginUserInfo.venderId == "1000003788"
        ? "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/wm_share.jpg"
        : loginUserInfo.venderId == "69268"
        ? "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/zj_share_pop.png"
        : loginUserInfo.venderId == "1000080364"
        ? "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/zj_share_jd.png"
        : "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/%E5%B0%8F%E7%A8%8B%E5%BA%8F%E5%88%86%E4%BA%AB%E5%9B%BE.jpg"; //丸美图片特殊处理
    case 41: // 华为-晒单有礼
      return require("@/assets/thdImg/common/share_sdyl.png");
    default:
      break;
  }
};

Vue.directive("preventReClick", {
  inserted(el, binding) {
    el.addEventListener("click", () => {
      if (!el.disabled) {
        el.disabled = true;
        setTimeout(() => {
          el.disabled = false;
        }, binding.value || 3000);
      }
    });
  },
});
let maidian = (value) => {
  if (window._hmt) {
    window._hmt.push([
      "_trackEvent",
      "按钮点击",
      "click",
      `${value.from}-${value.name}`,
    ]);
  }
};
// 按钮埋点
Vue.directive("zoom", {
  inserted(el, binding) {
    el.onclick = () => maidian(binding.value);
  },

  update(el, binding) {
    let old = binding.oldValue.from;
    let newV = binding.value.from;
    if (old != newV) {
      // console.log(el);
      // el.removeEventListener('click', ()=>maidian(binding.oldValue),false)
      el.onclick = false;
      el.onclick = () => maidian(binding.value);
    }
  },
});
// 标签埋点
Vue.directive("labelZoom", {
  inserted(el, binding) {
    el.addEventListener("click", () => {
      if (window._hmt) {
        window._hmt.push([
          "_trackEvent",
          "标签选择",
          "active",
          `${binding.value.name}`,
        ]);
      }
    });
  },
});
//百度统计代码
var _hmt = _hmt || [];
window._hmt = _hmt;
(function() {
  var hm = document.createElement("script");
  hm.src = hm.src =
    "https://hm.baidu.com/hm.js?68e65e77b10e09e3bff6192dcf88de08";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});
router.beforeEach((to, from, next) => {
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(["_trackPageview", "/" + to.fullPath]);
    }
  }
  const permission = checkPermisson(to.path);
  if (permission) {
    if (
      to.name == "smartPoster?activityType=25" ||
      to.name == "scratchers?activityType=26" ||
      to.name == "memberCard?activityType=32" ||
      to.name == "freeTrial?activityType=33"
    ) {
      authCheck({ subtype: to.query.activityType }).then((res) => {
        if (res.data.isNeedAuth) {
          window.open(res.data.authUrl, "_self");
          next();
        } else {
          next();
        }
      });
    } else {
      next();
    }
  } else {
    next("/integralCenter/home?permission=false");
  }

  //Note--测试不跳转
  // next();
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
